import { createStore } from 'vuex';
import auth from './modules/auth';
import products from './modules/products';
import licenses from './modules/licenses';
import theme from './modules/theme';
import customers from './modules/customers';
import tiers from './modules/tiers';
import activations from './modules/activations';
import usage from './modules/usage';
import audit from './modules/audit';
import { memoryOptimizer, memoryModule } from './plugins/memoryOptimizer';

const store = createStore({
  modules: {
    auth,
    products,
    licenses,
    theme,
    customers,
    tiers,
    activations,
    usage,
    audit,
    memory: memoryModule
  },
  plugins: [memoryOptimizer],

  // Global state for shared data
  state: () => ({
    globalError: null,
    isLoading: false,
    lastActivity: Date.now()
  }),

  mutations: {
    SET_GLOBAL_ERROR(state, error) {
      state.globalError = error;
    },

    SET_LOADING(state, loading) {
      state.isLoading = loading;
    },

    UPDATE_ACTIVITY(state) {
      state.lastActivity = Date.now();
    }
  },

  actions: {
    clearError({ commit }) {
      commit('SET_GLOBAL_ERROR', null);
    },

    setError({ commit }, error) {
      commit('SET_GLOBAL_ERROR', error);
      // Auto-clear error after 10 seconds
      setTimeout(() => {
        commit('SET_GLOBAL_ERROR', null);
      }, 10000);
    }
  },

  getters: {
    hasError: state => !!state.globalError,
    isInactive: state => {
      const inactivityThreshold = 30 * 60 * 1000; // 30 minutes
      return Date.now() - state.lastActivity > inactivityThreshold;
    }
  }
});

// Track user activity for memory optimization
if (typeof window !== 'undefined') {
  ['mousedown', 'keydown', 'scroll', 'touchstart'].forEach(eventType => {
    window.addEventListener(eventType, () => {
      store.commit('UPDATE_ACTIVITY');
    }, { passive: true });
  });

  // Clean up inactive sessions
  setInterval(() => {
    if (store.getters.isInactive) {
      // Clear non-essential data when inactive
      store.commit('licenses/SET_LICENSES', []);
      if (store.memoryOptimizer) {
        store.memoryOptimizer.cleanup();
      }
    }
  }, 5 * 60 * 1000); // Check every 5 minutes
}

export default store;